import { useState, useEffect } from 'react'
import SearchField from 'react-search-field';
import Select from 'react-select';

const ContentSelector = ({language, type, filter, isVisible, setIsVisible, callback}) => {
    const [header, setHeader] = useState('')
    const handleClose = async e => {
        setIsVisible(isVisible ? false : true)
    }

    let content


    content = (
        <>
            {(isVisible) && <div id="cc_overlay"></div>}
            <div id="cc_content-selector" className={`${type} ${isVisible ? '' : 'hidden'}`} >
                <div className="close-container">
                    <span className="result_response"></span>
                    <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
                </div>
                <h3>{header}</h3>
                <div id="cc_article_container">
                    <div id="articletype_list"></div>
                    {(type === 'contentType' && isVisible) && <ContentTypes allowMultiple={false}/>}
                    {(type === 'contentTypes' && isVisible) && <ContentTypes allowMultiple={true}/>}
                    {(type === 'contentModel' && isVisible) && <ContentModels allowMultiple={false}/>}
                    {(type === 'contentModels' && isVisible) && <ContentModels allowMultiple={true}/>}
                </div>
            </div>
        </>
    )

    function ContentTypes({allowMultiple}) {
        const [searchKeyword, setSearchKeyword] = useState('')
        const [filterSelect, setFilterSelect] = useState({value:0,label:language.value === 'DA' ? 'Ingen filter...' : 'No filter...'})
        const [contentModels, setContentModels] = useState([])
        const [contentTypes, setContentTypes] = useState([])
        const [contentTypesList, setContentTypesList] = useState(contentTypes)
        const [contentFilter, setContentFilter] = useState([])
        const [selectedContentTypes, setSelectedContentTypes] = useState([])
        useEffect(() => {
          
            const getData = async () => {
                const data = await fetchData()
                
                setContentTypes(data.contentTypes)
                setContentTypesList(data.contentTypes)
                setContentModels(data.contentModels)
                
                if(filter){
                    const filterModels = data.contentModels.filter((contentModel) => (filter.includes(contentModel.id)))
                    const filterList = filterModels.map((contentModel) => {
                        return {value: contentModel.id, label: contentModel.modelName};
                    })
                    setContentFilter([{value:0,label:language.value === 'DA' ? 'Ingen filter...' : 'No filter...'}, ...filterList])
                    setContentTypes(data.contentTypes.filter((contentType) => (filter.includes(contentType.contentModelId))))
                    setContentTypesList(data.contentTypes.filter((contentType) => (filter.includes(contentType.contentModelId))))
                }else{
                    const filterList = data.contentModels.map((contentModel) => {
                        return {value: contentModel.id, label: contentModel.modelName};
                    })
                    setContentFilter([{value:0,label:language.value === 'DA' ? 'Ingen filter...' : 'No filter...'}, ...filterList])
                }
                setHeader(language.value === 'DA' ? 'Vælg Indhold' : 'Select Content')
                
              }
              if(type && (type === 'contentType' || type === 'contentTypes')){
                getData()
              }
          },[type])

          const fetchData = async () => {

            var graphql = JSON.stringify({
                query: `query ($deleted: Boolean){
                            contentTypes(deleted: $deleted) {
                                id
                                contentTypeId 
                                contentTypeName
                                contentModelId
                                isDraft
                                published
                                publishDate
                                scheduleDate
                                
                                contentModel{
                                    modelName
                                }
                            }
                            contentModels{
                                id
                                modelName
                            }
                        }`,
                variables: {
                    "deleted": false
                }
              })
            const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
                method:'POST',
                headers:{
                    'Authorization':'Basic ' + global.config.Editor.authToken
                    ,'Content-Type': 'application/json'
                },
                body: graphql
            })
            .then(response => response.text())
            .then(result => {return JSON.parse(result).data})
            .catch(error => console.log('error', error))
            const data = await res
            return data
        }

        const filterContentModel = (selectedOption) => {
            setFilterSelect(selectedOption)
            filterContentTypes(searchKeyword, selectedOption.value)
        }
        
        const searchContentTypes = (keyword) => {
            setSearchKeyword(keyword)
            filterContentTypes(keyword,filterSelect.value)
        }
    
        const filterContentTypes = (keyword, contentModelId) => {
            setContentTypesList(
                contentTypes.filter((contentType) => 
                    (contentType.contentTypeName.toLowerCase().includes(keyword.toLowerCase()))
                    && (contentType.contentModelId === (contentModelId === 0 ? contentType.contentModelId : contentModelId))
                )
            )
        }

        const addContentType = (contentType) => {
            if(!allowMultiple){
                setSelectedContentTypes([contentType])
            }else{
                setSelectedContentTypes([...selectedContentTypes, contentType])
                //var newList = selectedContentTypes.concat(contentType)
                //setSelectedContentTypes(newList)
            }
        }
        
        const removeContentType = (contentType) => {
            const newList = selectedContentTypes.filter((item) => (item.id !== contentType.id))
            setSelectedContentTypes(newList)
        }

        const handleSelectedContentType = () => {
            callback(selectedContentTypes)
            setIsVisible(false)
        }

        return (
          <>
            <div id="cc_article_list_filter" className="cc_list_filter">
                <div className="filter-block">
                    <span>
                        {language.value === 'DA' ? 'Søg efter artikler' : 'Search for articles'}
                    </span>
                    
                    <Select key="filterSelect" className="filterSelect" classNamePrefix="filterSelect" options={contentFilter} onChange={filterContentModel} placeholder="Filter" />
                    <SearchField key="searchInput" classNames="searchInput" onChange={searchContentTypes} placeholder={language.value === 'DA' ? 'Søger i artikelnavn' : 'Search in article name'} autoComplete="off" />
                </div>
            </div>
            <div id="cc_article_list" className="cc_item_list">
                <label className="list-header">
                    <span className="name-container">{language.value === 'DA' ? 'Artikelnavn' : 'Articlename'}</span>
                    <span className="type-container">{language.value === 'DA' ? 'Artikeltype' : 'Articletype'}</span>
                    <span className="published-container">&nbsp;</span>
                    <span className="edit-container"></span>
                </label>
                {contentTypesList.map((contentType) => (
                    <label key={contentType.id} className={`list-item ${(selectedContentTypes.includes(contentType)) ? 'selected' : ''}`} data-id={contentType.contentTypeId} data-articlename="Tekstboks" data-articletype="Text" data-published="0">
                        <span className="name-container">{contentType.contentTypeName}</span>
                        <span className="type-container">{contentType.contentModel.modelName}</span>
                        <span className="published-container">&nbsp;</span>
                        <span className="edit-container">
                            {(selectedContentTypes) &&
                                <> 
                                {(!selectedContentTypes.includes(contentType)) && <i className="sprite-icon icon-plus" onClick={()=>addContentType(contentType)}></i>}
                                {(selectedContentTypes.includes(contentType)) && <i className="sprite-icon icon-close" onClick={()=>removeContentType(contentType)}></i>}
                                </>
                            }
                        </span>
                    </label>
                ))}
                {(selectedContentTypes) && 
                <div className="align_right">
                    <button onClick={handleSelectedContentType} className="cc-btn blue-gradient">{language.value === 'DA' ? 'GEM' : 'SAVE'}</button>
                </div>
                }
        
            </div>
        </>
        );
      }

      function ContentModels({allowMultiple}) {
        const [contentModels, setContentModels] = useState([])
        const [contentModelList, setContentModelList] = useState(contentModels)
        const [selectedContentModels, setSelectedContentModels] = useState([])
        useEffect(() => {
          
            const getData = async () => {
                const data = await fetchData()
                setContentModelList(data.contentModels)
                setContentModels(data.contentModels)
                setHeader(language.value === 'DA' ? 'Vælg Model' : 'Select Model')
              }
              if(type && (type === 'contentModel' || type === 'contentModels')){
                getData()
              }
          },[type])

          const fetchData = async () => {

            var graphql = JSON.stringify({
                query: `query {
                            contentModels{
                                id
                                modelName
                                modelType
                            }
                        }`,
                variables: {
                }
              })
            const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
                method:'POST',
                headers:{
                    'Authorization':'Basic ' + global.config.Editor.authToken
                    ,'Content-Type': 'application/json'
                },
                body: graphql
            })
            .then(response => response.text())
            .then(result => {return JSON.parse(result).data})
            .catch(error => console.log('error', error))
            const data = await res
            return data
        }
        
        const searchContentModels = (keyword) => {
            setContentModelList(
                contentModels.filter((contentModel) => (contentModel.modelName.toLowerCase().includes(keyword.toLowerCase())))
            )
        }

        const addContentModel = (contentModel) => {
            if(!allowMultiple){
                setSelectedContentModels([contentModel])
            }else{
                setSelectedContentModels([...selectedContentModels, contentModel])
            }
        }
        
        const removeContentModel = (contentModel) => {
            const newList = selectedContentModels.filter((item) => (item.id !== contentModel.id))
            setSelectedContentModels(newList)
        }

        const handleSelectedContentModel = () => {
            callback(selectedContentModels)
            setIsVisible(false)
        }

        return (
          <>
            <div id="cc_article_list_filter" className="cc_list_filter">
                <div className="filter-block">
                    <span>
                        {language.value === 'DA' ? 'Søg efter model' : 'Search for model'}
                    </span>
                    <SearchField key="searchInput" classNames="react-search-field-input searchInput" onChange={searchContentModels} placeholder={language.value === 'DA' ? 'Søger i modelnavn' : 'Search in model name'}  autoComplete="off"/>
                </div>
            </div>
            <div id="cc_article_list" className="cc_item_list">
                <label className="list-header">
                    <span className="name-container">{language.value === 'DA' ? 'Modelnavn' : 'Modelname'}</span>
                    <span className="type-container"></span>
                    <span className="published-container">{language.value === 'DA' ? 'Egenskab' : 'Property'}</span>
                    <span className="edit-container"></span>
                </label>
                {contentModelList.map((contentModel) => (
                    <label key={contentModel.id} className={`list-item ${(selectedContentModels.includes(contentModel)) ? 'selected' : ''}`} data-id={contentModel.id} data-articlename="Tekstboks" data-articletype="Text" data-published="0">
                        <span className="name-container">{contentModel.modelName}</span>
                        <span className="type-container"></span>
                        <span className="published-container">{contentModel.modelType}</span>
                        <span className="edit-container">
                            {(selectedContentModels) &&
                                <> 
                                {(!selectedContentModels.includes(contentModel)) && <i className="sprite-icon icon-plus" onClick={()=>addContentModel(contentModel)}></i>}
                                {(selectedContentModels.includes(contentModel)) && <i className="sprite-icon icon-close" onClick={()=>removeContentModel(contentModel)}></i>}
                                </>
                            }
                        </span>
                    </label>
                ))}
                {(selectedContentModels) && 
                <div className="align_right">
                    <button onClick={handleSelectedContentModel} className="cc-btn blue-gradient">{language.value === 'DA' ? 'GEM' : 'SAVE'}</button>
                </div>
                }
        
            </div>
        </>
        );
      }

    return (
        <>
            {content}
        </>
    )
}

export default ContentSelector
